// The three Quality reports as entries of the QA tab's left menu, under the group "AI Audit" (the owner's call, 2026-10-28: the reports live
// under the QA tab, not in a tab of their own). The QA tab keeps its own view ids for its engine; these three are drawn by React
// (components/Quality/Quality.js) and never reach that engine.

export const AI_GROUP_ID = 'aiaudit';
export const AI_PERMISSION = 'quality.view';

/** `view` is the id in the QA menu; `report` is what Quality.js draws; `param` is the short word in the address (?ai=weekly). */
export const AI_VIEWS = [
  { view: 'aiweekly', report: 'weekly', param: 'weekly', label: 'Weekly report', icon: 'checklist' },
  { view: 'aimonthly', report: 'monthly', param: 'monthly', label: 'Monthly report', icon: 'calendar' },
  { view: 'aipack', report: 'pack', param: 'pack', label: 'QA working pack', icon: 'target' }
];

export const isAiView = (view) => AI_VIEWS.some((v) => v.view === view);
export const reportOfAiView = (view) => (AI_VIEWS.find((v) => v.view === view) || {}).report || null;
/** The QA menu view an address word names ("monthly" is aimonthly), or null. */
export const aiViewFromParam = (param) => (AI_VIEWS.find((v) => v.param === String(param || '').toLowerCase()) || {}).view || null;

/**
 * Where the old Quality tab address goes now. `/cs-reports/quality?view=monthly&month=2026-10` becomes the QA tab with the same report open
 * (`/cs-reports/qa?ai=monthly&month=2026-10`), so a saved link or a bookmark still lands on the same page.
 */
export function legacyQualityTarget(search) {
  const old = new URLSearchParams(search || '');
  const next = new URLSearchParams();
  next.set('ai', ['weekly', 'monthly', 'pack'].includes(old.get('view')) ? old.get('view') : 'weekly');
  if (old.get('week')) next.set('week', old.get('week'));
  if (old.get('month')) next.set('month', old.get('month'));
  return `/cs-reports/qa?${next.toString()}`;
}
